import React, { useReducer, useEffect } from 'react';

import {
  TextField,
} from '@material-ui/core';

import { validate } from '../../../utils/validators';
import './Input.css';

const inputReducer = (state, action) => {
  console.log(action);
  switch (action.type) {
    case 'CHANGE':
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators)
      };
    case 'TOUCH':
      return {
        ...state,
        isTouched: true
      };
    default:
      return state;
  }
};
const Input = (props) => {
  const {
    id,
    element,
    placeholder,
    label,
    type,
    rows,
    step,
    name,
    extraClass,
    dica,
    fullWidth,
    variant,
    errorText,
    onInput,
    validators,
    initialValue,
    initialValid,
    endAdornment,
    multiline,
    InputProps,
    InputLabelProps,
    disabled,
    format
  } = props;

  const [inputState, dispatch] = useReducer(inputReducer, {
    value: initialValue || '',
    isValid: initialValid || false,
    isTouched: initialValid || false
  });

  const {
    value,
    isValid
  } = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, value, isValid, onInput]);

  const changeHandler = (event) => {
    if (props.type === 'checkbox') {
      dispatch({ type: 'CHANGE', val: event.target.checked, validators });
    } else {
      dispatch({ type: 'CHANGE', val: event.target.value, validators });
    }
  };
  const touchHandler = (event) => {
    console.log(event);
    dispatch({ type: 'TOUCH' });
  };

  const elemento = element === 'input' ? (
    <TextField
      error={!inputState.isValid && inputState.isTouched}
      fullWidth={fullWidth}
      helperText={!inputState.isValid && inputState.isTouched ? errorText : dica}
      label={label}
      id={id}
      margin="normal"
      name={name}
      step={step}
      onChange={changeHandler}
      onBlur={touchHandler}
      type={type}
      disabled={disabled}
      rows={rows}
      format={format}
      multiline={multiline}
      placeholder={placeholder}
      InputProps={InputProps}
      value={inputState.value}
      variant={variant}
      endAdornment={endAdornment}
      InputLabelProps={InputLabelProps}
      className={extraClass}
    />
  ) : (
    <textarea
      className={`form-control ${extraClass} ${!inputState.isValid && inputState.isTouched && 'is-invalid'}`}
      id={id}
      rows={rows || 3}
      placeholder={placeholder}
      onChange={changeHandler}
      onBlur={touchHandler}
      value={inputState.value}
    />
  );

  return (
    <div>
      {elemento}
    </div>
  );
};
export default Input;
